export const SNavWrapper = {
  width: { xs: 191, sm: 251 }, 
  overflow: 'auto', 
  px: '10px'
}; 
